<template>
  <div class="login-page">
    <!-- Left panel -->
    <div class="login-left">
      <AuthLeftPanel />
    </div>

    <!-- Right panel -->
    <div class="login-right">
      <!-- Tabs — info card-тай адил дээр, бүтэн өргөнтэй -->
      <!-- Комекс идэвхтэй үед л таб харагдана (VUE_APP_ACTIVE_COMEX) -->
      <div v-if="useComex" class="login-tabs">
        <button
          class="login-tab text-label"
          :class="{ 'login-tab--active': activeTab === 'stock' }"
          type="button"
          @click="activeTab = 'stock'"
        >
          Хөрөнгийн зах зээлийн арилжаа
        </button>
        <button
          class="login-tab text-label"
          :class="{ 'login-tab--active': activeTab === 'mining' }"
          type="button"
          @click="activeTab = 'mining'"
        >
          Уул уурхайн бүтээгдэхүүн арилжаа
        </button>
      </div>

      <div class="login-box">
        <h5 class="form-title text-heading">
          {{ $t("login.title") || "Нэвтрэх" }}
        </h5>
        <p class="form-subtitle text-body-sm">
          {{
            $t("login.description") ||
            "Системд нэвтрэхийн тулд бүртгэлтэй имэйл хаягаа оруулна уу."
          }}
        </p>

        <b-alert :show="passwordResetSuccess" variant="success" class="mb-3">{{
          $t("login.password_reset_success")
        }}</b-alert>
        <b-alert :show="danSetupSuccess" variant="success" class="mb-3">{{
          $t("login.dan_setup_success")
        }}</b-alert>

        <!-- Түгжигдсэн бүртгэл зөвхөн нууц үг сэргээснээр нээгдэнэ -->
        <b-alert :show="accountLocked" variant="danger" class="mb-3">
          {{ lockMessage }}
          <div class="mt-1">
            <strong v-if="isLocked">{{ $t("login.locked_countdown", { time: lockCountdown }) }}</strong>
            <router-link
              v-else
              :to="{ path: '/user/forgot-password', query: { email: form.email.trim() } }"
            >
              <strong>{{ $t("login.reset_required") }}</strong>
            </router-link>
          </div>
        </b-alert>

        <b-form @submit.prevent="onSubmit">
          <!-- <label class="text-label">{{ $t("login.email") }}</label> -->
          <UITextField
            v-model="form.email"
            type="email"
            :label="$t('login.email_placeholder')"
          />

          <!-- <label class="text-label">{{ $t("login.password") }}</label> -->
          <UITextField
            v-model="form.password"
            type="password"
            :label="$t('login.password_placeholder')"
          />

          <div class="login-options">
            <label class="remember-me">
              <input
                v-model="rememberMe"
                type="checkbox"
                class="remember-me__input"
              />
              <span class="remember-me__box"></span>
              <span class="text-body-xs">{{ $t("login.remember_me") || "Намайг сана" }}</span>
            </label>
            <router-link to="/user/forgot-password" class="forgot-link text-body-xs">
              {{ $t("login.forgot_password") || "Нууц үгээ мартсан уу?" }}
            </router-link>
          </div>

          <UIButton
            type="submit"
            :label="$t('login.submit')"
            variant="primary"
            :block="true"
            :loading="loading"
            :disabled="accountLocked"
            class="mt-3"
          />
        </b-form>

        <div class="login-divider text-body-xs">
          <span>{{ $t("login.or") || "эсвэл" }}</span>
        </div>

        <button
          type="button"
          class="emongolia-btn"
          :disabled="danLoading"
          :title="$t('login.emongolia_hint')"
          @click="loginWithDan"
        >
          <img src="/img/emongolia_blue.svg" alt="e-Mongolia" />
        </button>
        <p class="emongolia-hint text-body-xs">{{ $t("login.emongolia_hint") }}</p>

        <UIButton
          :label="$t('login.register_link')"
          variant="secondary"
          :block="true"
          @click="$router.push('/user/register')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from "../../components/UI/UIButton.vue";
import AuthLeftPanel from "../../components/UI/AuthLeftPanel.vue";
import UITextField from "../../components/UI/UITextField.vue";
import danApi from "../../api/danApi";
import lockCountdownMixin from "../../mixins/lockCountdownMixin";
import env from "@/utils/env";

const REMEMBERED_EMAIL_KEY = "atlas_remembered_email";

export default {
  name: "LoginPage",
  components: { UIButton, AuthLeftPanel, UITextField },
  mixins: [lockCountdownMixin],
  data() {
    return {
      activeTab: "stock",
      useComex: env("VUE_APP_ACTIVE_COMEX") === "true",
      logoUrl: process.env.VUE_APP_LOGO_URL || "/img/logo.svg",
      form: { email: "", password: "" },
      rememberMe: false,
      loading: false,
      logoFailed: false,
      passwordResetSuccess: this.$route.query.reset === "success",
      danSetupSuccess: this.$route.query.dan === "success",
      danLoading: false,
      lockMessage: "",
      accountLocked: false,
    };
  },
  watch: {
    // Түгжээ нь и-мэйл тус бүрд хамаарна
    "form.email"() {
      this.accountLocked = false;
      this.stopLockCountdown();
    },
  },
  mounted() {
    const rememberedEmail = localStorage.getItem(REMEMBERED_EMAIL_KEY);
    if (rememberedEmail) {
      this.form.email = rememberedEmail;
      this.rememberMe = true;
    }
    // e-Mongolia-аар имэйл тохируулсны дараа имэйлийг бөглөж өгнө
    if (this.danSetupSuccess && this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
  },
  methods: {
    async loginWithDan() {
      this.danLoading = true;
      try {
        await danApi.startVerify();
      } catch (err) {
        this.danLoading = false;
        this.$bvToast.toast(this.$t("dan_setup.error_generic"), {
          title: "e-Mongolia",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },
    onLogoError() {
      this.logoFailed = true;
    },
    async onSubmit() {
      if (this.accountLocked) return;
      this.loading = true;
      try {
        await this.$store.dispatch("auth/login", {
          email: this.form.email,
          password: this.form.password,
        });
        if (this.rememberMe) {
          localStorage.setItem(REMEMBERED_EMAIL_KEY, this.form.email.trim());
        } else {
          localStorage.removeItem(REMEMBERED_EMAIL_KEY);
        }
        this.$router.push("/user/trade/sto");
      } catch (err) {
        const data = err?.response?.data;
        // 429: аль хэдийн түгжигдсэн. 401 + seconds: энэ оролдлогоор хязгаарт хүрч түгжигдлээ.
        if (err?.response?.status === 429 || data?.seconds !== undefined) {
          this.accountLocked = true;
          this.lockMessage = data?.message || this.$t("login.locked");
          // seconds: нууц үг сэргээх боломжтой болох хүртэлх хугацаа (0 бол одоо сэргээж болно)
          this.startLockCountdown(data?.seconds);
          return;
        }
        const msg = data?.message || this.$t("login.error_generic");
        this.$bvToast.toast(msg, {
          title: "Нэвтрэх амжилтгүй",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ── Layout ── */
.login-page {
  min-height: 100vh;
  display: flex;
}

.login-left {
  flex: 0 0 50%;
  overflow: hidden;
}

.login-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 48px 40px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10%;
  padding-top: 100px;
}

@media (max-width: 768px) {
  .login-left {
    display: none;
  }
  .login-right {
    width: 100%;
  }
}

/* ── Box ── */
.login-box {
  width: 100%;
  max-width: 350px;
}

/* ── Tabs ── */
.login-tabs {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 52px;
}
.login-tab {
  flex: 1;
  background: none;
  border: none;
  border-bottom: 2px solid #e4e7ef;
  padding: 14px 18px;
  font-size: 13.5px;
  font-weight: 500;
  color: #aab0bc;
  cursor: pointer;
  position: relative;
  transition: color 0.18s;
  outline: none;
  white-space: nowrap;
  text-align: center;
}
.login-tab--active {
  color: #2d3f9c;
  font-weight: 700;
}
.login-tab--active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #2d3f9c;
  border-radius: 2px 2px 0 0;
}
@media (max-width: 992px) {
  .login-tabs {
    margin-bottom: 40px;
  }
  .login-tab {
    padding: 12px 14px; 
    font-size: 13px;    
    white-space: normal;
    line-height: 1.3;
  }
}
@media (max-width: 576px) {
  .login-tabs {
    margin-bottom: 32px; 
  }

  .login-tab {
    padding: 10px 8px;  
    font-size: 12px;   
    white-space: normal; 
    line-height: 1.3;
  }
}

/* ── Titles ── */
.form-title {
  color: #1a2035;
  margin-bottom: 6px;
}
.form-subtitle {
  color: #71717a !important;
  margin-bottom: 24px;
  line-height: 1.5;
}

/* ── Remember me / Forgot password ── */
.login-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 0 4px;
}
.remember-me {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #71717a;
  margin: 0;
}
.remember-me__input {
  display: none;
}
.remember-me__box {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border: 1.5px solid #d0d5e0;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.remember-me__input:checked + .remember-me__box {
  background-color: #2d3f9c;
  border-color: #2d3f9c;
}
.remember-me__input:checked + .remember-me__box::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.forgot-link {
  color: #2d3f9c;
  font-weight: 500;
  text-decoration: none;
}
.forgot-link:hover {
  text-decoration: underline;
}

/* ── e-Mongolia ── */
.emongolia-btn {
  display: block;
  width: 100%;
  background: none;
  border: 1px solid #e4e7ef;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 6px;
  cursor: pointer;
}
.emongolia-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.emongolia-btn img {
  height: 24px;
}
.emongolia-hint {
  color: #aab0bc !important;
  text-align: center;
  margin-bottom: 12px;
}

/* ── Divider ── */
.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
  color: #aab0bc !important;
}
.login-divider::before,
.login-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e4e7ef;
}
</style>
